import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Header } from '../components/layout/Header';
import TeamVacationGrid from '../components/TeamVacationGrid';

const VacationCalendarPage = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'worker' && !user.is_admin) return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <div className="max-w-7xl mx-auto px-4 py-6" data-testid="vacation-calendar-page">
        <div className="flex items-center gap-3 mb-4">
          <h1 className="text-2xl font-semibold text-slate-800">Vacaciones</h1>
          <span className="text-sm text-slate-500">Inicio · Panel · Vacaciones</span>
        </div>
        <TeamVacationGrid />
      </div>
    </div>
  );
};

export default VacationCalendarPage;
